import React from "react"

import classNames from '@utils/classnames'
import styles from "./clickableImage.module.scss"

const ClickableImage = ({ src, linkClassName, ...props }) => {
  return (
    <a
      href={src}
      target="_blank"
      className={classNames(styles.link, linkClassName)}
    >
      <img src={src} {...props} />
    </a>
  )
}

export default ClickableImage
